import { render } from "./InfoPersonalSection.vue?vue&type=template&id=701d98f2"
import script from "./InfoPersonalSection.vue?vue&type=script&lang=js"
export * from "./InfoPersonalSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__